export function ModalAlert({ show, setShow, onClick }) {
	return (
		<>
			{show && (
				<div className='tw-w-screen tw-h-screen tw-absolute tw-top-0 tw-left-0 tw-bg-black/50 tw-backdrop-blur-sm tw-flex tw-items-center tw-justify-center'>
					<div className='tw-w-[546px] tw-bg-white tw-rounded-md tw-p-6'>
						<span className='tw-text-base tw-mb-8 tw-mt-4'>¿Seguro que quieres eliminar esta crítica? Esta es una acción irreversible.</span>
						<div className='tw-flex tw-justify-end tw-items-center tw-gap-2'>
							<button onClick={() => setShow(false)} className='tw-my-2 tw-w-full tw-rounded-full tw-py-2 tw-bg-white hover:tw-bg-gray-50 active:tw-bg-gray-100 border'>
								Cancelar
							</button>
							<button onClick={onClick} className='tw-font-bold tw-w-full tw-rounded-full tw-py-2 tw-bg-error-500 tw-text-white hover:tw-bg-error-600 active:tw-bg-error-700' style={{ border: '1px solid rgb(244, 63,94)' }}>
								Eliminar evaluación
							</button>
						</div>
					</div>
				</div>
			)}
		</>
	)
}
